<template>
  <div>
    <ValidationObserver slim ref="observer">
      <UserInfo
        :user="wipUser"
        :included="wipIncluded"
        :loading="submitting"
        @submit="onUserInfoSubmit"
      />
    </ValidationObserver>
  </div>
</template>

<script>
import UserInfo from '@/components/Users/UserInfo.vue';
import { userComputed, userMethods } from '@/store/adminHelper';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'TheUser',
  mixins: [veeValidateErrorsMixin],
  components: {
    UserInfo,
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
  }),
  computed: {
    ...userComputed,
  },
  methods: {
    ...userMethods,
    onUserInfoSubmit(userData) {
      const { userId } = this;
      this.submitting = true;
      this.updateUser({ userId, userData })
        .then(() => {
          this.setWip({ ...this.user });
          this.submitting = false;
        })
        .catch((error) => {
          this.onError(error);
          this.submitting = false;
        });
    },
    onError({ status, data }) {
      if (status === 422) {
        const { errors } = data;
        this.observer = this.$refs.observer;
        this.addServerErrors(errors);
      }
    },
  },
};
</script>
